/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { Icon } from 'common-components';
import { useTranslationContext } from '../contexts/translationContext';
import styles from './notification.module.scss';

const EmptyNotification = () => {
    const { translate } = useTranslationContext();

    return (
        <div className={styles.notification} style={{ '--top': '0rem' } as any}>
            <div className={styles['no-notification-icon']}>
                <Icon name="noNotificationsIcon"></Icon>
            </div>
            <div className={styles['user-name-content-wrapper-no-notifications']}>
                <div className={styles.username}>{translate('NoNotifications')}</div>
                <div className={styles.content}>{translate('Yet')}</div>
            </div>
        </div>
    );
};

export default EmptyNotification;
